import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsyncClickDirective } from './async-click.directive';
import { BackButtonDirective } from './back-button.directive';
import { RippleHoverDirective } from './ripple-hover.directive';



@NgModule({
  declarations: [
    AsyncClickDirective,
    BackButtonDirective,
    RippleHoverDirective
  ],
    exports: [
        AsyncClickDirective,
        BackButtonDirective
    ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
